import { GET } from './Httpr.js';


export async function getCourseById(idCursada){
    let url = 'courses/getById';
    let requestData = {
        id: idCursada
    }

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function getCoursesByUser(){
    let url = 'courses/byUser';
    
    let rsp = await GET(url, {});

    return rsp;
}